import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import api from "../lib/apiClient";
import { toast } from "sonner";

export default function AdminPlans() {
  const [data, setData] = useState(null);
  const [draft, setDraft] = useState({});
  const load = () => api.get("/admin/plans").then((r) => {
    setData(r.data);
    const d = {};
    Object.entries(r.data.catalog).forEach(([p, c]) => { d[p] = { label: c.label || p, monthly: c.monthly ?? "", yearly: c.yearly ?? "" }; });
    setDraft(d);
  }).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (plan) => {
    const c = draft[plan];
    try {
      await api.put(`/admin/plans/${plan}`, {
        label: c.label,
        monthly: c.monthly === "" ? null : Number(c.monthly),
        yearly: c.yearly === "" ? null : Number(c.yearly),
      });
      toast.success("Offre enregistrée");
    } catch { toast.error("Échec"); }
  };

  if (!data) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-amber-500 animate-spin" /></div>;
  return (
    <div className="space-y-5" data-testid="admin-plans">
      <h1 className="font-display text-3xl font-extrabold">Offres & fonctionnalités</h1>
      {data.free_mode && (
        <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-300" data-testid="admin-freemode-banner">
          Mode gratuit actif : toutes les fonctionnalités sont débloquées. Les prix ci-dessous sont des placeholders, modifiables à tout moment (aucun paiement réel).
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-4">
        {Object.entries(data.catalog).map(([plan, c]) => (
          <div key={plan} className="bg-[#18181E] border border-zinc-800 rounded-2xl p-5 space-y-3" data-testid={`admin-plan-card-${plan}`}>
            <div className="flex items-center justify-between">
              <span className="font-display text-lg font-bold">{plan}</span>
              <span className="text-[10px] font-mono uppercase text-zinc-500">{c.role}</span>
            </div>
            <label className="block text-xs text-zinc-500">Libellé
              <input value={draft[plan]?.label ?? ""} onChange={(e) => setDraft((d) => ({ ...d, [plan]: { ...d[plan], label: e.target.value } }))}
                data-testid={`plan-label-${plan}`} className="mt-1 w-full h-10 bg-[#0F0F13] border border-zinc-800 rounded-lg px-3 text-sm text-zinc-200 outline-none focus:border-amber-500/50" /></label>
            <div className="flex gap-2">
              <label className="flex-1 text-xs text-zinc-500">Prix mensuel (€)
                <input type="number" value={draft[plan]?.monthly ?? ""} placeholder="—" onChange={(e) => setDraft((d) => ({ ...d, [plan]: { ...d[plan], monthly: e.target.value } }))}
                  data-testid={`plan-monthly-${plan}`} className="mt-1 w-full h-10 bg-[#0F0F13] border border-zinc-800 rounded-lg px-3 text-sm text-zinc-200 outline-none focus:border-amber-500/50" /></label>
              <label className="flex-1 text-xs text-zinc-500">Prix annuel (€)
                <input type="number" value={draft[plan]?.yearly ?? ""} placeholder="—" onChange={(e) => setDraft((d) => ({ ...d, [plan]: { ...d[plan], yearly: e.target.value } }))}
                  data-testid={`plan-yearly-${plan}`} className="mt-1 w-full h-10 bg-[#0F0F13] border border-zinc-800 rounded-lg px-3 text-sm text-zinc-200 outline-none focus:border-amber-500/50" /></label>
            </div>
            <div className="flex flex-wrap gap-1">
              {(c.entitlements || []).slice(0, 10).map((e) => (
                <span key={e} className="text-[10px] px-2 py-0.5 rounded-full bg-zinc-900 border border-zinc-800 text-zinc-400">{e}</span>
              ))}
            </div>
            <button onClick={() => save(plan)} data-testid={`plan-save-${plan}`}
              className="h-10 px-4 rounded-xl gold-gradient text-black font-semibold text-sm inline-flex items-center gap-2"><Save className="w-4 h-4" /> Enregistrer</button>
          </div>
        ))}
      </div>
    </div>
  );
}
